import { render, staticRenderFns } from "./FileRegisterFields.vue?vue&type=template&id=13f4227e&"
import script from "./FileRegisterFields.vue?vue&type=script&lang=js&"
export * from "./FileRegisterFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports